// extracted by mini-css-extract-plugin
module.exports = {"account":"view-account_account__1cvOD","intro":"view-account_intro__2yUBK","link":"view-account_link__17e90","paymentRequestForm":"view-account_paymentRequestForm__1xbJU"};